import React from "react";
import { Row } from "reactstrap";
import { SaveAndExit } from "../../components/buttons/saveAndexit";
import { baseUrl } from "../../libs/env";
import SubmitButton from "../../components/buttons/SubmitButton";
import NextButton from "../../components/buttons/NextButton";
import BackButton from "../../components/buttons/BackButton";

export const StudentButtonPannel = ({
  data,
  currentPage,
  setCurrentPage,
  IsonRecorder,
  isReview,
  creatQuizDataThenSaveAndExit,
  isSubmitting,
  creatQuizDataAndSave,
  saveQuizInterval,
}) => {
  return (
    <Row className="pb-3">
      <div class="col-12 d-flex">
        <div className="col-6">
          {isReview ? (
            <a
              href={`${baseUrl}`}
              style={{ backgroundColor: "#ee3b3b", color: "white", width: "100px" }}
              class="btn center"
            >
              <svg className="me-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V1H1V2H2ZM7.95956 9.37377C8.35008 9.7643 8.98325 9.7643 9.37377 9.37377C9.7643 8.98325 9.7643 8.35008 9.37377 7.95956L7.95956 9.37377ZM3 7.33333V2H1V7.33333H3ZM2 3H7.33333V1H2V3ZM1.29289 2.70711L7.95956 9.37377L9.37377 7.95956L2.70711 1.29289L1.29289 2.70711Z" fill="white"/>
                <path d="M2.66602 10.0003V10.0003C2.66602 10.3099 2.66602 10.4646 2.67743 10.5951C2.80432 12.0455 3.95421 13.1954 5.40455 13.3222C5.53503 13.3337 5.68981 13.3337 5.99935 13.3337H7.99935C10.1855 13.3337 11.2786 13.3337 12.0534 12.7911C12.3401 12.5904 12.5894 12.3411 12.7901 12.0544C13.3327 11.2796 13.3327 10.1865 13.3327 8.00033V6.00033C13.3327 5.69078 13.3327 5.53601 13.3213 5.40552C13.1944 3.95518 12.0445 2.8053 10.5942 2.67841C10.4637 2.66699 10.3089 2.66699 9.99935 2.66699V2.66699" stroke="white" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <b>Exit</b></a>
          ) : (
            <>
              <div class="inline float-start">
                <SaveAndExit
                  click={creatQuizDataThenSaveAndExit}
                  disabled={isSubmitting}
                />
              </div>
              {/* <div class="inline float-start ms-2 lg-display">
                <>
                  <Savebtn click={creatQuizDataAndSave} disabled={isSubmitting} />
                  <ToastContainer />
                </>
              </div> */}
            </>
          )}
        </div>
        <div className="col-6">
          {currentPage === data.total_pages && !isReview && (
            <div className="float-end">
              <SubmitButton isSubmitting={isSubmitting} IsonRecorder={IsonRecorder} />
            </div>
          )}
          {currentPage !== data.total_pages && !isReview && (
            <div className="float-end me-1">
              <NextButton
                IsonRecorder={IsonRecorder}
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
              />
            </div>
          )}
          {currentPage > 1 && !isReview && (
            <div className="float-end me-1">
              <BackButton
                IsonRecorder={IsonRecorder}
                onClick={() => {
                  setCurrentPage(currentPage - 1);
                }}
              />
            </div>
          )}
        </div>
      </div>

    </Row>
  );
};
